import { render, staticRenderFns } from "./InPageNavDesktop.vue?vue&type=template&id=05bcf528&"
import script from "./InPageNavDesktop.vue?vue&type=script&lang=js&"
export * from "./InPageNavDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports